// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ocultar el scrollbar en Chrome */
*::-webkit-scrollbar {
  width: 0 !important;
}

/* Estilos específicos para el componente app-cards-real-estate */
:host {
  display: block !important;
  width: 100% !important;
  max-width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  box-sizing: border-box !important;
}

/* Asegurar que todos los contenedores del componente usen todo el ancho */
:host > * {
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box !important;
}

/* Contenedor de filtros también debe usar todo el ancho */
.filter-bar-container-mobile,
.filter-bar-container-desktop {
  width: 100% !important;
  max-width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  box-sizing: border-box !important;
}

/* ======================================
   FILTER BAR AND CARD CONTAINER FIXES
   ====================================== */

/* Base filter container styles */
.filter-bar-container-mobile {
  width: 100%;
  position: relative;
}

.filter-bar-container-desktop {
  width: 100%;
  margin-bottom: 0;
}

/* Improved filter bar mobile */
.filter-bar-mobile {
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 0.75rem;
  z-index: 10;
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  display: none !important; /* Forzar que esté oculto por defecto */
  opacity: 0;
  visibility: hidden;
}

.filter-bar-mobile.show {
  display: block !important; /* Forzar que se muestre cuando tenga la clase show */
  opacity: 1 !important;
  visibility: visible !important;
  z-index: 10;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.filter-bar-mobile.hide {
  transform: translateY(-10%);
  opacity: 0;
  visibility: hidden;
}

/* Filter toggle button */
.toggle-filter-btn {
  margin: 0px 10px;
  background-color: #ff8c00;
  color: #ffffff;
  border: 2px solid transparent;
  border-radius: 8px;
  padding: 0.5rem;
  margin-bottom: 1rem;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s;
  width: auto;
  display: flex;
  align-items: center;
}

.toggle-filter-btn:hover {
  background-color: #e57a00;
  transform: scale(1.02);
}

/* Barra de filtros */
.filter-bar-mobile,
.desktop-filter-bar {
  margin-bottom: 0.25rem;
}

/* Filter inputs and controls */
.filter-bar-mobile input,
.desktop-filter-bar input,
.filter-bar-mobile select,
.desktop-filter-bar select,
.filter-bar-mobile button,
.desktop-filter-bar button,
.filter-bar-mobile .date-picker,
.desktop-filter-bar .desktop-date-picker {
  flex: 1 1 auto;       /* Todos ocupan el mismo espacio disponible */
  min-width: 110px;      /* Puedes ajustar este valor según el espacio que dispongas */
  padding: 0.5rem;       /* Asegura consistencia en el padding */
  border: 2px solid #F09502;
  border-radius: 8px;
  font-size: 0.9rem;
  width: 100% !important;
  height: 2.25rem !important;
  box-sizing: border-box;
}

.filter-bar-mobile .filter-btn {
  flex: 1 1 calc(50% - 10px);
  text-align: center;
}

.filter-buttons {
  display: flex;
  width: 100%;
  gap: 6px;
}

.filter-bar-mobile input[type="text"],
.desktop-filter-bar input[type="text"],
.filter-bar-mobile select,
.desktop-filter-bar select,
.filter-bar-mobile button,
.desktop-filter-bar button {
  flex: 1;
  padding: 0.5rem;
  border: 2px solid #F09502;
  border-radius: 8px;
  font-size: 0.9rem;
  height: 2.25rem; 
  padding: 0.25rem 0.5rem;
}

.filter-bar-mobile select.order-by-dropdown,
.desktop-filter-bar select.order-by-dropdown {
  margin-right: 10px;
}

.filter-bar-mobile button,
.desktop-filter-bar button {
  background-color: #FF8C00;
  color: #FFFFFF;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

.filter-bar-mobile button:hover,
.desktop-filter-bar button:hover {
  background-color: #E57A00;
  transform: scale(1.01);
}

.filter-btn,
.reset-button {
  background-color: #ff8c00;
  color: #ffffff;
  border: none !important;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s;
  width: 100% !important;
  height: 100% !important;
}

.filter-btn:hover,
.reset-button:hover {
  background-color: #e57a00;
  transform: scale(1.02);
}

/* Date picker container */
.date-picker-container {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  background-color: #fff;
  gap: 4px;
  border: 2px solid #F09502;
  border-radius: 8px;
  font-size: 0.9rem;
  height: 2.25rem;
  padding: 0 8px !important;
  width: 100% !important;
  box-sizing: border-box;
}

.desktop-date-picker,
.date-picker {
  position: relative;
  padding: 0px;
}

.date-picker-toggle {
  color: gray;
}

.desktop-date-picker-input,
.date-picker {
  flex: 1;
}

.desktop-date-picker-input {
  border: none !important;
  background: transparent !important;
  padding: 0 4px !important;
  height: 90% !important;
  font-size: 0.9rem !important;
  width: 40% !important;
}

/* Cards container */
.cards-container {
  width: 100% !important;
  max-width: 100% !important;
  overflow-y: auto;
  box-sizing: border-box;
  margin: 0 !important;
  padding: 0 10px !important;
  position: relative;
  z-index: 2; /* Asegurar que el contenedor de cards esté por encima del fondo */
}

.cards-container .row {
  width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  box-sizing: border-box;
  display: flex !important;
  flex-wrap: wrap !important;
}

/* Card styling */
.cards-container .col-lg-4,
.cards-container .col-md-6,
.cards-container .col-12 {
  padding: 0.5rem !important;
  transition: transform 0.2s;
  flex: 0 0 auto !important;
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box !important;
}

/* Estilos específicos para tarjetas */
app-card-real-estate {
  display: block;
  width: 100%;
  height: 100%;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  z-index: 2; /* Asegurar que las cards estén por encima del fondo */
}

/* Navegación y paginación */
.navigationCards {
  width: 100% !important;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 100px;
}

.navigationCards nav {
  margin-right: 5px;
}

.page-item a {
  color: #f09502 !important;
}

.pagination-controls {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin: 1rem auto;
  padding: 0.5rem;
  width: 100%;
}

.pagination-controls .btn-prev,
.pagination-controls .btn-next {
  background-color: #ff8c00;
  color: #ffffff;
  border: 2px solid #ffffff;
  border-radius: 8px;
  padding: 0.5rem;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s;
}

.pagination-controls .btn-prev:hover:not([disabled]),
.pagination-controls .btn-next:hover:not([disabled]) {
  background-color: #e57a00;
  transform: scale(1.05);
}

.pagination-controls .btn-prev[disabled],
.pagination-controls .btn-next[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-page {
  padding: 8px 14px;
  border: 1px solid #d48402;
  background-color: transparent;
  color: #d48402;
  border-radius: 20px;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s, border-color 0.3s;
  font-size: 14px;
}

.btn-page.active {
  background-color: #d48402;
  color: #fff;
  font-weight: bold;
  border-color: #d48402;
}

.btn-page:hover:not(.active) {
  background-color: rgba(212, 132, 2, 0.2);
  color: #d48402;
}

.ellipsis {
  padding: 8px 12px;
  color: #999;
  cursor: default;
  font-size: 14px;
}

.btn-prev:hover,
.btn-next:hover {
  background-color: rgba(212, 132, 2, 0.2);
  color: #d48402;
}

.no-properties-message {
  text-align: center;
  color: #fff;
  font-size: 1.5rem;
  font-weight: bold;
  margin: 2rem auto;
  padding: 1rem;
  border-radius: 15px;
  border: 3px solid #f09502;
}

/* Scrollbar personalizado para contenedores con scroll */
.scrollable-container::-webkit-scrollbar {
  width: 12px;
}

.scrollable-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
  border: 1px solid #F09502;
}

.scrollable-container::-webkit-scrollbar-thumb {
  background: #F09502;
  border-radius: 10px;
  border: 1px solid #f1f1f1;
}

.scrollable-container::-webkit-scrollbar-thumb:hover {
  background: #d48402;
}

.scrollable-container::-webkit-scrollbar,
.scrollable-container::-webkit-scrollbar {
  width: 12px !important;
}

/* Angular Material overrides */
::ng-deep .mat-date-range-input-container.mat-date-range-input-container {
  align-items: normal;
}

::ng-deep .mat-date-range-input-start-wrapper {
  width: 50% !important;
  max-width: 50% !important;
}

::ng-deep .mat-date-range-input-end-wrapper {
  width: 50% !important;
  max-width: 50% !important;
}

::ng-deep .mat-date-range-input-separator {
  margin: 8px 4px !important;
  color: gray;
}

/* ======================================
   RESPONSIVE MEDIA QUERIES
   ====================================== */

/* Mobile (Small screens) */
@media (max-width: 576px) {
  /* Show mobile filters, hide desktop */
  .filter-bar-container-desktop {
    display: none !important;
  }
  
  .filter-bar-container-mobile {
    display: block !important;
  }

  /* Mobile filter toggle behavior */
  .filter-bar-mobile {
    display: none !important;
    opacity: 0 !important;
    visibility: hidden !important;
  }
  
  .filter-bar-mobile.show {
    display: block !important;
    width: 97vw !important;
    opacity: 1 !important;
    visibility: visible !important;
  }
  
  /* Single column layout for filters */
  .filter-bar-mobile.show .custom-grid {
    display: flex !important;
    flex-direction: column !important;
    gap: 0.75rem !important;
    width: 100% !important;
  }
  
  /* Single column cards - IMPORTANTE: Asegurar ancho completo */
  .cards-container {
    padding: 0 5px !important;
    height: calc(100vh - 200px) !important; /* ✅ Reducir altura para iPhone SE */
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    position: relative;
    z-index: 2; /* Asegurar que esté por encima del fondo azul */
  }
  
  .cards-container .row {
    display: flex !important;
    flex-direction: column !important;
    width: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
  }
  
  .cards-container .col-lg-4,
  .cards-container .col-md-6,
  .cards-container .col-12 {
    width: 100% !important;
    max-width: 100% !important;
    flex: 0 0 100% !important;
    padding: 0.375rem !important;
    margin: 0 !important;
  }
  
  /* Asegurar que la navbar-router-container no tenga padding extra */
  .navbar-router-container {
    padding: 0 !important;
    width: 100% !important;
  }
  
  /* Ocultar scrollbar en móvil */
  .scrollable-container::-webkit-scrollbar {
    display: none;
  }
  
  .scrollable-container {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  
  /* Pagination en móvil */
  .pagination-controls {
    display: flex;
    justify-content: center;
    gap: 1rem;
    width: 100%;
  }
}

/* Tablet (Small to medium screens) */
@media (min-width: 577px) and (max-width: 767px) {
  /* Show mobile filters, hide desktop */
  .filter-bar-container-desktop {
    display: none !important;
  }
  
  .filter-bar-container-mobile {
    display: block !important;
  }
  
  /* Mobile filter toggle behavior */
  .filter-bar-mobile {
    display: none !important;
    opacity: 0 !important;
    visibility: hidden !important;
  }
  
  .filter-bar-mobile.show {
    display: block !important;
    width: 94vw !important;
    opacity: 1 !important;
    visibility: visible !important;
  }
  
  /* Two column layout for filters */
  .filter-bar-mobile.show .custom-grid {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 0.5rem !important;
    width: 100% !important;
  }
  
  .filter-bar-mobile.show .custom-grid > div:nth-last-child(2),
  .filter-bar-mobile.show .custom-grid > div:last-child {
    grid-column: span 2 !important;
  }
  
  /* Two column cards - IMPORTANTE: Asegurar ancho completo */
  .cards-container {
    padding: 0 5px !important;
    height: calc(100vh - 260px) !important;
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    position: relative;
    z-index: 2; /* Asegurar que esté por encima del fondo azul */
  }
  
  .cards-container .row {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 0.5rem !important;
    width: 100% !important;
    padding: 0.25rem !important;
    margin: 0 !important;
  }
  
  .cards-container .col-lg-4,
  .cards-container .col-md-6,
  .cards-container .col-12 {
    width: 100% !important;
    max-width: 100% !important;
    flex: none !important;
    padding: 0.25rem !important;
    margin: 0 !important;
  }
  
  /* Asegurar que la navbar-router-container no tenga padding extra */
  .navbar-router-container {
    padding: 0 !important;
    width: 100% !important;
  }
  
  .custom-grid .custom-col.first-row {
    flex: 1 1 50%;
    max-width: 50%;
  }
  
  .custom-grid .custom-col.second-row {
    flex: 1 1 100%;
    max-width: 100%;
  }
}

/* iPad and larger tablets (768px - 1024px) */
/* Corrección para iPad y tablets (768px - 1366px) */
/* Mejorar layout del grid de filtros para iPad y tablets */
@media (min-width: 768px) and (max-width: 1366px) {
  /* Estilos generales para el contenedor mobile y sus elementos */
  .filter-bar-container-mobile {
    display: block !important;
    position: relative !important;
    z-index: 100 !important;
    width: 100% !important;
    padding: 0 10px !important;
    box-sizing: border-box !important;
  }
  
  /* Ocultar barra de filtros desktop */
  .filter-bar-container-desktop {
    display: none !important;
  }
  
  /* Botón toggle centrado y con buen tamaño */
  .toggle-filter-btn {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 100% !important;
    margin: 0 0 15px 0 !important;
    padding: 10px !important;
    background-color: #ff8c00 !important;
    color: white !important;
    border-radius: 8px !important;
    border: none !important;
    font-size: 16px !important;
    cursor: pointer !important;
  }
  
  /* Estilos para la barra de filtros cuando está oculta */
  .filter-bar-mobile {
    display: none !important;
  }
  
  /* Estilos para la barra de filtros cuando está visible */
  .filter-bar-mobile.show {
    display: block !important;
    width: 100% !important;
    background: white !important;
    border-radius: 8px !important;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1) !important;
    padding: 15px !important;
    margin-bottom: 20px !important;
    box-sizing: border-box !important;
  }
  
  /* Estructura de grid mejorada con más espacio entre elementos */
  .filter-bar-mobile.show .custom-grid {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 15px !important;
    width: 100% !important;
  }

  /* Dar suficiente altura a cada elemento del grid */
  .filter-bar-mobile.show .custom-grid > div {
    min-height: 45px !important;
  }
  
  /* Estilos para los inputs, selects y date pickers */
  .filter-bar-mobile.show input,
  .filter-bar-mobile.show select {
    width: 100% !important;
    height: 45px !important;
    padding: 8px 12px !important;
    border: 2px solid #F09502 !important;
    border-radius: 8px !important;
    font-size: 14px !important;
    background-color: white !important;
    box-sizing: border-box !important;
  }
  
  /* Mejorar el contenedor del date picker */
  .filter-bar-mobile.show .date-picker-container {
    display: flex !important;
    align-items: center !important;
    width: 100% !important;
    height: 45px !important;
    padding: 0 12px !important;
    border: 2px solid #F09502 !important;
    border-radius: 8px !important;
    background-color: white !important;
    box-sizing: border-box !important;
  }
  
  /* Mejorar la visibilidad de las fechas */
  .filter-bar-mobile.show .desktop-date-picker-input {
    width: 40% !important;
    height: 35px !important;
    border: none !important;
    background: transparent !important;
    font-size: 14px !important;
    text-align: center !important;
    box-sizing: border-box !important;
  }
  
  /* Estilos para el botón de resetear filtros */
  .filter-bar-mobile.show .filter-buttons {
    grid-column: span 2 !important;
    width: 100% !important;
  }
  
  .filter-bar-mobile.show .filter-btn {
    width: 100% !important;
    height: 45px !important;
    padding: 8px 12px !important;
    background-color: #ff8c00 !important;
    color: white !important;
    border: none !important;
    border-radius: 8px !important;
    font-size: 16px !important;
    cursor: pointer !important;
    box-sizing: border-box !important;
  }

  /* Asegurar que los elementos ocupen todo el espacio */
  .filter-bar-mobile.show .col-lg,
  .filter-bar-mobile.show .col-lg-4,
  .filter-bar-mobile.show .col-md-6,
  .filter-bar-mobile.show .col-sm-6,
  .filter-bar-mobile.show .col-sx-12 {
    width: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
  }
  
  /* Posicionamiento de elementos en grid para mayor claridad */
  .filter-bar-mobile.show .custom-grid > div:nth-child(1) {
    grid-column: 1 / 2 !important;
    grid-row: 1 / 2 !important;
  }
  
  .filter-bar-mobile.show .custom-grid > div:nth-child(2) {
    grid-column: 2 / 3 !important;
    grid-row: 1 / 2 !important;
  }
  
  .filter-bar-mobile.show .custom-grid > div:nth-child(3) {
    grid-column: 1 / 2 !important;
    grid-row: 2 / 3 !important;
  }
  
  .filter-bar-mobile.show .custom-grid > div:nth-child(4) {
    grid-column: 2 / 3 !important;
    grid-row: 2 / 3 !important;
  }
  
  .filter-bar-mobile.show .custom-grid > div:nth-child(5) {
    grid-column: 1 / 3 !important;
    grid-row: 3 / 4 !important;
  }
}

/* Ajustes para el contenedor de tarjetas */
/* Corrección específica para el grid de filtros manteniendo el ancho de las cards */
@media (min-width: 768px) and (max-width: 1366px) {
  /* Estilos generales para el contenedor mobile y sus elementos */
  .filter-bar-container-mobile {
    display: block !important;
    position: relative !important;
    z-index: 100 !important;
    width: 100vw !important; /* Usar viewport width */
    max-width: 100vw !important;
    padding: 0 10px !important;
    box-sizing: border-box !important;
  }
  
  /* Ocultar barra de filtros desktop */
  .filter-bar-container-desktop {
    display: none !important;
  }
  
  /* Botón toggle */
  .toggle-filter-btn {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: calc(100% - 20px) !important;
    margin: 0 10px 15px 10px !important;
  }
  
  /* Estilos para la barra de filtros cuando está visible */
  .filter-bar-mobile.show {
    display: block !important;
    width: calc(100% - 20px) !important; /* Ancho completo con margen lateral */
    margin: 0 10px !important;
    background: white !important;
    border-radius: 8px !important;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1) !important;
    padding: 15px !important;
    box-sizing: border-box !important;
  }
  
  /* Estructura de grid simplificada: 2 columnas, y el botón abajo ocupando todo el ancho */
  .filter-bar-mobile.show .custom-grid {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 15px !important;
    width: 100% !important;
  }
  
  /* El botón de resetear filtros ocupa todo el ancho */
  .filter-bar-mobile.show .custom-grid > div:last-child {
    grid-column: 1 / 3 !important; /* Span 2 columnas */
  }
  
  /* Centrar el texto del botón */
  .filter-bar-mobile.show .filter-btn {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    width: 100% !important;
    height: 45px !important;
    background-color: #ff8c00 !important;
    color: white !important;
    font-size: 16px !important;
    border: none !important;
    border-radius: 8px !important;
  }
  
  /* Mejorar inputs y selects */
  .filter-bar-mobile.show input,
  .filter-bar-mobile.show select,
  .filter-bar-mobile.show .date-picker-container {
    width: 100% !important;
    height: 45px !important;
    padding: 8px 12px !important;
    border: 2px solid #F09502 !important;
    border-radius: 8px !important;
    box-sizing: border-box !important;
  }
}

/* MANTENER LOS ESTILOS DE LAS CARDS QUE YA FUNCIONAN CORRECTAMENTE */
@media (min-width: 768px) and (max-width: 1366px) {
  /* No tocar el estilo de las cards */
  .cards-container {
    padding: 0 10px !important;
    width: 100% !important; /* Usar ancho del contenedor padre */
    max-width: 100% !important;
    height: calc(100vh - 260px) !important;
    margin: 0 !important;
    box-sizing: border-box !important;
    position: relative;
    z-index: 2; /* Asegurar que esté por encima del fondo azul */
  }

  /* Configuración de grid de 2 columnas ocupando todo el ancho */
  .cards-container .row {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 1rem !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    box-sizing: border-box !important;
  }

  /* Asegurar que cada celda del grid ocupe su espacio */
  .cards-container .col-lg-4,
  .cards-container .col-md-6,
  .cards-container .col-12 {
    width: 100% !important;
    max-width: 100% !important;
    flex: none !important;
    padding: 0 !important;
    margin-bottom: 0.25rem !important;
    box-sizing: border-box !important;
  }

  /* Asegurar que la tarjeta ocupe todo el ancho de su contenedor */
  app-card-real-estate {
    display: block !important;
    width: 100% !important;
    height: 100% !important;
  }

  .toggle-filter-btn {
    width: 200px !important; /* Ancho fijo reducido */
    margin: 0 0 15px 10px !important; /* Alineado a la izquierda con margen izquierdo */
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    height: 45px !important;
    background-color: #ff8c00 !important;
    color: white !important;
    border: none !important;
    border-radius: 8px !important;
    font-size: 16px !important;
    box-sizing: border-box !important;
  }
}





/* Large tablets and small desktops (1025px - 1366px) */
@media (min-width: 1024px) and (max-width: 1366px) {
  /* Hide mobile filters, show desktop */
  .filter-bar-container-mobile {
    display: none !important;
  }
  
  .filter-bar-container-desktop {
    display: block !important;
  }
  
  /* Horizontal flex layout for desktop filters */
  .desktop-filter-bar .custom-grid {
    display: flex !important;
    flex-wrap: nowrap !important;
    gap: 10px !important;
    width: 100% !important;
    align-items: center !important;
  }
  
  /* Equal width columns */
  .desktop-filter-bar .custom-col {
    flex: 1 1 0 !important;
    min-width: 0 !important;
    max-width: none !important;
  }
  
  /* Three column cards for large tablets/small desktops */
  .cards-container {
    height: calc(100vh - 250px) !important;
    padding: 0 10px !important;
    width: 100% !important;
    max-width: 100% !important;
    position: relative;
    z-index: 2; /* Asegurar que esté por encima del fondo azul */
  }
  
  .cards-container .row {
    display: grid !important;
    grid-template-columns: repeat(3, 1fr) !important;
    gap: 1rem !important;
    width: 100% !important;
    padding: 0.5rem !important;
  }
  
  .cards-container .col-lg-4,
  .cards-container .col-md-6,
  .cards-container .col-12 {
    width: 100% !important;
    max-width: 100% !important;
    flex: none !important;
    padding: 0 !important;
    margin-bottom: 0.5rem !important;
  }
  
  .custom-grid .custom-col.first-row {
    flex: 1 1 33.33%;
    max-width: 33.33%;
  }
  
  .custom-grid .custom-col.second-row {
    flex: 1 1 50%;
    max-width: 50%;
  }
  
  /* Date picker container en desktop */
  .desktop-filter-bar .date-picker-container {
    flex: 1 1 auto;
    min-width: 180px;
    max-width: 200px;
    padding: 0.5rem;
  }
  
  .desktop-filter-bar .date-picker-container input {
    font-size: 0.9rem;
  }
  
  /* Resetear la estructura del grid para una fila única */
  .desktop-filter-bar .row.w-100.g-2.custom-grid {
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: nowrap !important;
    width: 100% !important;
    gap: 10px;
    margin: 0 !important;
  }
  
  /* Dimensiones uniformes para todas las columnas */
  .desktop-filter-bar .custom-col,
  .desktop-filter-bar .custom-col.first-row,
  .desktop-filter-bar .custom-col.second-row,
  .desktop-filter-bar .custom-col.col-reset {
    flex: 1 !important;
    width: auto !important;
    max-width: none !important;
    padding: 0 !important;
    margin: 0 !important;
  }
  
  /* Uniformidad en inputs, selects y date picker */
  .desktop-filter-bar input[type="text"],
  .desktop-filter-bar select,
  .desktop-filter-bar .date-picker-container {
    width: 100% !important;
    height: 2.25rem !important;
    padding: 0 8px !important;
    min-width: unset !important;
    max-width: unset !important;
  }
}

/* Larger desktops (1367px+) */
@media (min-width: 1367px) {
  /* Hide mobile filters, show desktop */
  .filter-bar-container-mobile {
    display: none !important;
  }
  
  .filter-bar-container-desktop {
    display: block !important;
  }
  
  /* Desktop filter layout */
  .desktop-filter-bar {
    display: flex !important;
    flex-direction: row !important;
    align-items: center;
    width: 100%;
    gap: 10px;
    justify-content: space-between;
  }
  
  .desktop-filter-bar .row.w-100.g-2.custom-grid {
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: nowrap !important;
    width: 100% !important;
    gap: 10px;
    margin: 0 !important;
  }
  
  .desktop-filter-bar .custom-col {
    flex: 1 !important;
    width: auto !important;
    max-width: none !important;
    padding: 0 !important;
    margin: 0 !important;
  }
  
  .desktop-filter-bar input[type="text"],
  .desktop-filter-bar select,
  .desktop-filter-bar .date-picker-container {
    width: 100% !important;
    height: 2.25rem !important;
    min-width: unset !important;
    max-width: unset !important;
  }
  
  /* Standard card grid */
  .cards-container {
    height: calc(100vh - 170px);
    padding: 0 10px;
    width: 100% !important;
    max-width: 100% !important;
    position: relative;
    z-index: 2; /* Asegurar que esté por encima del fondo azul */
  }
  
  /* Ajustar el botón de resetear filtros */
  .desktop-filter-bar .filter-buttons {
    width: 100% !important;
    display: flex;
    height: 2.25rem !important;
    flex: 1 !important;
  }
  
  .desktop-filter-bar .filter-buttons .reset-button {
    width: 100% !important;
    height: 100% !important;
    min-width: unset !important;
    max-width: unset !important;
    white-space: nowrap;
  }
  
  /* Date picker en desktop grande */
  .date-picker-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
  }
  
  .date-picker-container input.desktop-date-picker-input {
    font-size: 0.92rem;
    text-align: center;
    padding: 0 4px;
    height: 35px;
    line-height: 1.2;
    box-sizing: border-box;
  }
  
  .date-picker-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 35px;
  }
}

/* Ajustes específicos para diferentes rangos de pantalla */
@media (max-width: 1440px) and (min-width: 1325px) {
  .cards-container {
    height: calc(100vh - 250px);
    position: relative;
    z-index: 2; /* Asegurar que esté por encima del fondo azul */
  }
}

@media (max-width: 1325px) {
  .cards-container {
    height: calc(100vh - 310px);
    position: relative;
    z-index: 2; /* Asegurar que esté por encima del fondo azul */
  }
}

@media (min-width: 992px) {
  .filter-bar-mobile button,
  .desktop-filter-bar button {
    min-width: 80px;
    width: auto;
    flex: 0 0 auto;
  }
}

/* Solución final para grid desktop - 3 columnas */

/* Solución final para grid desktop - 3 columnas con scrollbar visible */

/* Larger desktops (1367px+) */
@media (min-width: 1367px) {
  /* Asegurar que tenemos 3 columnas */
  .cards-container {
    display: flex !important;
    flex-wrap: wrap !important;
    width: 100% !important;
    max-width: 100% !important;
    height: calc(100vh - 170px) !important;
    padding: 0 10px !important;
    overflow-y: auto !important;
    position: relative;
    z-index: 2; /* Asegurar que esté por encima del fondo azul */
  }

  /* Ajustar el contenedor de las tarjetas */
  .cards-container.row {
    margin-right: 0 !important;
    margin-left: 0 !important;
    width: 100% !important;
  }

  /* Cada columna ocupa exactamente 1/3 del espacio */
  .cards-container .col-lg-4 {
    flex: 0 0 33.333333% !important;
    max-width: 33.333333% !important;
    padding: 0.5rem !important;
    box-sizing: border-box !important;
  }

  /* Asegurar que cada tarjeta ocupa todo el ancho de su columna */
  app-card-real-estate {
    display: block !important;
    width: 100% !important;
    height: 100% !important;
  }
  
  /* Restaurar scrollbar en desktop grande */
  .scrollable-container::-webkit-scrollbar {
    display: block !important;
    width: 12px !important;
  }
  
  .scrollable-container {
    -ms-overflow-style: auto !important;
    scrollbar-width: auto !important;
  }
  
  /* Restaurar estilos de scrollbar personalizados */
  .scrollable-container::-webkit-scrollbar-track {
    background: #f1f1f1 !important;
    border-radius: 10px !important;
    border: 1px solid #F09502 !important;
  }
  
  .scrollable-container::-webkit-scrollbar-thumb {
    background: #F09502 !important;
    border-radius: 10px !important;
    border: 1px solid #f1f1f1 !important;
  }
  
  .scrollable-container::-webkit-scrollbar-thumb:hover {
    background: #d48402 !important;
  }
}

/* Large tablets and small desktops (1025px - 1366px) */
@media (min-width: 1025px) and (max-width: 1366px) {
  /* Asegurar que tenemos 3 columnas también aquí */
  .cards-container {
    display: flex !important;
    flex-wrap: wrap !important;
    width: 100% !important;
    max-width: 100% !important;
    height: calc(100vh - 220px) !important;
    padding: 0 10px !important;
    overflow-y: auto !important;
    position: relative;
    z-index: 2; /* Asegurar que esté por encima del fondo azul */
  }

  /* Ajustar el contenedor de las tarjetas */
  .cards-container.row {
    margin-right: 0 !important;
    margin-left: 0 !important;
    width: 100% !important;
  }

  /* Cada columna ocupa exactamente 1/3 del espacio */
  .cards-container .col-lg-4 {
    flex: 0 0 33.333333% !important;
    max-width: 33.333333% !important;
    padding: 0.5rem !important;
    box-sizing: border-box !important;
  }

  /* Asegurar que cada tarjeta ocupa todo el ancho de su columna */
  app-card-real-estate {
    display: block !important;
    width: 100% !important;
    height: 100% !important;
  }
  
  /* Restaurar scrollbar también para medianos desktop */
  .scrollable-container::-webkit-scrollbar {
    display: block !important;
    width: 12px !important;
  }
  
  .scrollable-container {
    -ms-overflow-style: auto !important;
    scrollbar-width: auto !important;
  }
  
  /* Restaurar estilos de scrollbar personalizados */
  .scrollable-container::-webkit-scrollbar-track {
    background: #f1f1f1 !important;
    border-radius: 10px !important;
    border: 1px solid #F09502 !important;
  }
  
  .scrollable-container::-webkit-scrollbar-thumb {
    background: #F09502 !important;
    border-radius: 10px !important;
    border: 1px solid #f1f1f1 !important;
  }
  
  .scrollable-container::-webkit-scrollbar-thumb:hover {
    background: #d48402 !important;
  }
}

/* Corregir alineación del contenedor de paginación */
.pagination-controls {
  flex: 0 0 100% !important;
  width: 100% !important;
  justify-content: center !important;
  margin-top: 1rem !important;
  padding: 0.5rem !important;
}

/* Corregir problemas con el ng-container */
.cards-container > ng-container {
  display: contents !important;
}

/* ======================================
   SPINNER STYLES
   ====================================== */
.spinner-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #181b25;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  backdrop-filter: blur(2px);
}

.spinner-container mat-spinner {
  width: 80px !important;
  height: 80px !important;
  margin-bottom: 30px;
}

.spinner-container .loading-text {
  color: white;
  font-size: 20px;
  font-weight: 500;
  text-align: center;
  margin-top: 20px;
  font-family: "Montserrat", sans-serif;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

/* Asegurar que el spinner tenga el color correcto */
.spinner-container .frontProgress {
  color: #f09502 !important;
}

`, "",{"version":3,"sources":["webpack://./src/app/components/cards-real-estate/cards-real-estate.component.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;EACE,mBAAmB;AACrB;;AAEA,iEAAiE;AACjE;EACE,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;EAC1B,oBAAoB;EACpB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA,0EAA0E;AAC1E;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA,0DAA0D;AAC1D;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,oBAAoB;EACpB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;;2CAE2C;;AAE3C,iCAAiC;AACjC;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gEAAgE;EAChE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,wBAAwB,EAAE,uCAAuC;EACjE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,yBAAyB,EAAE,qDAAqD;EAChF,qBAAqB;EACrB,8BAA8B;EAC9B,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,UAAU;EACV,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,iDAAiD;EACjD,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;;EAEE,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;;;;;;;;EAQE,cAAc,QAAQ,6CAA6C;EACnE,gBAAgB,OAAO,6DAA6D;EACpF,eAAe,QAAQ,uCAAuC;EAC9D,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,QAAQ;AACV;;AAEA;;;;;;EAME,OAAO;EACP,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,uBAAuB;AACzB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,2DAA2D;AAC7D;;AAEA;;EAEE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,iDAAiD;EACjD,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;EAEE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,sBAAsB;EACtB,QAAQ;EACR,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,OAAO;AACT;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,0BAA0B;EAC1B,kBAAkB;EAClB,UAAU,EAAE,kEAAkE;AAChF;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;;;EAGE,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA,sCAAsC;AACtC;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU,EAAE,sDAAsD;AACpE;;AAEA,4BAA4B;AAC5B;EACE,sBAAsB;EACtB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,iDAAiD;AACnD;;AAEA;;EAEE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gEAAgE;EAChE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,yDAAyD;AACzD;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;;2CAE2C;;AAE3C,2BAA2B;AAC3B;EACE,sCAAsC;EACtC;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,kCAAkC;EAClC;IACE,wBAAwB;IACxB,qBAAqB;IACrB,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,8BAA8B;EAChC;;EAEA,qCAAqC;EACrC;IACE,wBAAwB;IACxB,iCAAiC;IACjC,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA,8DAA8D;EAC9D;IACE,yBAAyB;IACzB,sCAAsC,EAAE,oCAAoC;IAC5E,sBAAsB;IACtB,0BAA0B;IAC1B,oBAAoB;IACpB,kBAAkB;IAClB,UAAU,EAAE,gDAAgD;EAC9D;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,sBAAsB;IACtB,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;;;IAGE,sBAAsB;IACtB,0BAA0B;IAC1B,yBAAyB;IACzB,4BAA4B;IAC5B,oBAAoB;EACtB;;EAEA,mEAAmE;EACnE;IACE,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA,+BAA+B;EAC/B;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;IACxB,qBAAqB;EACvB;;EAEA,wBAAwB;EACxB;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,WAAW;EACb;AACF;;AAEA,qCAAqC;AACrC;EACE,sCAAsC;EACtC;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,kCAAkC;EAClC;IACE,wBAAwB;IACxB,qBAAqB;IACrB,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,8BAA8B;EAChC;;EAEA,kCAAkC;EAClC;IACE,wBAAwB;IACxB,gDAAgD;IAChD,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA,2DAA2D;EAC3D;IACE,yBAAyB;IACzB,sCAAsC;IACtC,sBAAsB;IACtB,0BAA0B;IAC1B,oBAAoB;IACpB,kBAAkB;IAClB,UAAU,EAAE,gDAAgD;EAC9D;;EAEA;IACE,wBAAwB;IACxB,gDAAgD;IAChD,sBAAsB;IACtB,sBAAsB;IACtB,2BAA2B;IAC3B,oBAAoB;EACtB;;EAEA;;;IAGE,sBAAsB;IACtB,0BAA0B;IAC1B,qBAAqB;IACrB,2BAA2B;IAC3B,oBAAoB;EACtB;;EAEA,mEAAmE;EACnE;IACE,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;AACF;;AAEA,6CAA6C;AAC7C,oDAAoD;AACpD,2DAA2D;AAC3D;EACE,gEAAgE;EAChE;IACE,yBAAyB;IACzB,6BAA6B;IAC7B,uBAAuB;IACvB,sBAAsB;IACtB,0BAA0B;IAC1B,iCAAiC;EACnC;;EAEA,qCAAqC;EACrC;IACE,wBAAwB;EAC1B;;EAEA,4CAA4C;EAC5C;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,sBAAsB;IACtB,6BAA6B;IAC7B,wBAAwB;IACxB,oCAAoC;IACpC,uBAAuB;IACvB,6BAA6B;IAC7B,uBAAuB;IACvB,0BAA0B;IAC1B,0BAA0B;EAC5B;;EAEA,wDAAwD;EACxD;IACE,wBAAwB;EAC1B;;EAEA,yDAAyD;EACzD;IACE,yBAAyB;IACzB,sBAAsB;IACtB,4BAA4B;IAC5B,6BAA6B;IAC7B,oDAAoD;IACpD,wBAAwB;IACxB,8BAA8B;IAC9B,iCAAiC;EACnC;;EAEA,gEAAgE;EAChE;IACE,wBAAwB;IACxB,gDAAgD;IAChD,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA,mDAAmD;EACnD;IACE,2BAA2B;EAC7B;;EAEA,oDAAoD;EACpD;;IAEE,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;IAC5B,oCAAoC;IACpC,6BAA6B;IAC7B,0BAA0B;IAC1B,kCAAkC;IAClC,iCAAiC;EACnC;;EAEA,0CAA0C;EAC1C;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,oCAAoC;IACpC,6BAA6B;IAC7B,kCAAkC;IAClC,iCAAiC;EACnC;;EAEA,yCAAyC;EACzC;IACE,qBAAqB;IACrB,uBAAuB;IACvB,uBAAuB;IACvB,kCAAkC;IAClC,0BAA0B;IAC1B,6BAA6B;IAC7B,iCAAiC;EACnC;;EAEA,8CAA8C;EAC9C;IACE,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;IAC5B,oCAAoC;IACpC,uBAAuB;IACvB,uBAAuB;IACvB,6BAA6B;IAC7B,0BAA0B;IAC1B,0BAA0B;IAC1B,iCAAiC;EACnC;;EAEA,sDAAsD;EACtD;;;;;IAKE,sBAAsB;IACtB,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA,6DAA6D;EAC7D;IACE,6BAA6B;IAC7B,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;IAC7B,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;IAC7B,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;IAC7B,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;IAC7B,0BAA0B;EAC5B;AACF;;AAEA,2CAA2C;AAC3C,oFAAoF;AACpF;EACE,gEAAgE;EAChE;IACE,yBAAyB;IACzB,6BAA6B;IAC7B,uBAAuB;IACvB,uBAAuB,EAAE,wBAAwB;IACjD,2BAA2B;IAC3B,0BAA0B;IAC1B,iCAAiC;EACnC;;EAEA,qCAAqC;EACrC;IACE,wBAAwB;EAC1B;;EAEA,iBAAiB;EACjB;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,mCAAmC;IACnC,mCAAmC;EACrC;;EAEA,yDAAyD;EACzD;IACE,yBAAyB;IACzB,mCAAmC,EAAE,sCAAsC;IAC3E,yBAAyB;IACzB,4BAA4B;IAC5B,6BAA6B;IAC7B,oDAAoD;IACpD,wBAAwB;IACxB,iCAAiC;EACnC;;EAEA,yFAAyF;EACzF;IACE,wBAAwB;IACxB,gDAAgD;IAChD,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA,qDAAqD;EACrD;IACE,6BAA6B,EAAE,oBAAoB;EACrD;;EAEA,+BAA+B;EAC/B;IACE,wBAAwB;IACxB,kCAAkC;IAClC,8BAA8B;IAC9B,sBAAsB;IACtB,uBAAuB;IACvB,oCAAoC;IACpC,uBAAuB;IACvB,0BAA0B;IAC1B,uBAAuB;IACvB,6BAA6B;EAC/B;;EAEA,6BAA6B;EAC7B;;;IAGE,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;IAC5B,oCAAoC;IACpC,6BAA6B;IAC7B,iCAAiC;EACnC;AACF;;AAEA,qEAAqE;AACrE;EACE,oCAAoC;EACpC;IACE,0BAA0B;IAC1B,sBAAsB,EAAE,oCAAoC;IAC5D,0BAA0B;IAC1B,sCAAsC;IACtC,oBAAoB;IACpB,iCAAiC;IACjC,kBAAkB;IAClB,UAAU,EAAE,gDAAgD;EAC9D;;EAEA,+DAA+D;EAC/D;IACE,wBAAwB;IACxB,gDAAgD;IAChD,oBAAoB;IACpB,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;IACrB,iCAAiC;EACnC;;EAEA,sDAAsD;EACtD;;;IAGE,sBAAsB;IACtB,0BAA0B;IAC1B,qBAAqB;IACrB,qBAAqB;IACrB,iCAAiC;IACjC,iCAAiC;EACnC;;EAEA,iEAAiE;EACjE;IACE,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,uBAAuB,EAAE,wBAAwB;IACjD,gCAAgC,EAAE,iDAAiD;IACnF,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,uBAAuB;IACvB,oCAAoC;IACpC,uBAAuB;IACvB,uBAAuB;IACvB,6BAA6B;IAC7B,0BAA0B;IAC1B,iCAAiC;EACnC;AACF;;;;;;AAMA,uDAAuD;AACvD;EACE,sCAAsC;EACtC;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,+CAA+C;EAC/C;IACE,wBAAwB;IACxB,4BAA4B;IAC5B,oBAAoB;IACpB,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA,wBAAwB;EACxB;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA,wDAAwD;EACxD;IACE,sCAAsC;IACtC,0BAA0B;IAC1B,sBAAsB;IACtB,0BAA0B;IAC1B,kBAAkB;IAClB,UAAU,EAAE,gDAAgD;EAC9D;;EAEA;IACE,wBAAwB;IACxB,gDAAgD;IAChD,oBAAoB;IACpB,sBAAsB;IACtB,0BAA0B;EAC5B;;EAEA;;;IAGE,sBAAsB;IACtB,0BAA0B;IAC1B,qBAAqB;IACrB,qBAAqB;IACrB,gCAAgC;EAClC;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA,qCAAqC;EACrC;IACE,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,wDAAwD;EACxD;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,4BAA4B;IAC5B,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA,kDAAkD;EAClD;;;;IAIE,kBAAkB;IAClB,sBAAsB;IACtB,0BAA0B;IAC1B,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA,iDAAiD;EACjD;;;IAGE,sBAAsB;IACtB,0BAA0B;IAC1B,yBAAyB;IACzB,2BAA2B;IAC3B,2BAA2B;EAC7B;AACF;;AAEA,8BAA8B;AAC9B;EACE,sCAAsC;EACtC;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,0BAA0B;EAC1B;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,SAAS;IACT,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,4BAA4B;IAC5B,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,0BAA0B;IAC1B,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;;;IAGE,sBAAsB;IACtB,0BAA0B;IAC1B,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA,uBAAuB;EACvB;IACE,2BAA2B;IAC3B,eAAe;IACf,sBAAsB;IACtB,0BAA0B;IAC1B,kBAAkB;IAClB,UAAU,EAAE,gDAAgD;EAC9D;;EAEA,yCAAyC;EACzC;IACE,sBAAsB;IACtB,aAAa;IACb,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA,kCAAkC;EAClC;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;EACd;AACF;;AAEA,2DAA2D;AAC3D;EACE;IACE,2BAA2B;IAC3B,kBAAkB;IAClB,UAAU,EAAE,gDAAgD;EAC9D;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,kBAAkB;IAClB,UAAU,EAAE,gDAAgD;EAC9D;AACF;;AAEA;EACE;;IAEE,eAAe;IACf,WAAW;IACX,cAAc;EAChB;AACF;;AAEA,kDAAkD;;AAElD,wEAAwE;;AAExE,8BAA8B;AAC9B;EACE,oCAAoC;EACpC;IACE,wBAAwB;IACxB,0BAA0B;IAC1B,sBAAsB;IACtB,0BAA0B;IAC1B,sCAAsC;IACtC,0BAA0B;IAC1B,2BAA2B;IAC3B,kBAAkB;IAClB,UAAU,EAAE,gDAAgD;EAC9D;;EAEA,0CAA0C;EAC1C;IACE,0BAA0B;IAC1B,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA,mDAAmD;EACnD;IACE,+BAA+B;IAC/B,gCAAgC;IAChC,0BAA0B;IAC1B,iCAAiC;EACnC;;EAEA,gEAAgE;EAChE;IACE,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA,0CAA0C;EAC1C;IACE,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,mCAAmC;IACnC,gCAAgC;EAClC;;EAEA,kDAAkD;EAClD;IACE,8BAA8B;IAC9B,8BAA8B;IAC9B,oCAAoC;EACtC;;EAEA;IACE,8BAA8B;IAC9B,8BAA8B;IAC9B,oCAAoC;EACtC;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA,uDAAuD;AACvD;EACE,iDAAiD;EACjD;IACE,wBAAwB;IACxB,0BAA0B;IAC1B,sBAAsB;IACtB,0BAA0B;IAC1B,sCAAsC;IACtC,0BAA0B;IAC1B,2BAA2B;IAC3B,kBAAkB;IAClB,UAAU,EAAE,gDAAgD;EAC9D;;EAEA,0CAA0C;EAC1C;IACE,0BAA0B;IAC1B,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA,mDAAmD;EACnD;IACE,+BAA+B;IAC/B,gCAAgC;IAChC,0BAA0B;IAC1B,iCAAiC;EACnC;;EAEA,gEAAgE;EAChE;IACE,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA,sDAAsD;EACtD;IACE,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,mCAAmC;IACnC,gCAAgC;EAClC;;EAEA,kDAAkD;EAClD;IACE,8BAA8B;IAC9B,8BAA8B;IAC9B,oCAAoC;EACtC;;EAEA;IACE,8BAA8B;IAC9B,8BAA8B;IAC9B,oCAAoC;EACtC;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA,qDAAqD;AACrD;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kCAAkC;EAClC,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA,2CAA2C;AAC3C;EACE,4BAA4B;AAC9B;;AAEA;;2CAE2C;AAC3C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,yCAAyC;AAC3C;;AAEA,oDAAoD;AACpD;EACE,yBAAyB;AAC3B","sourcesContent":["/* Ocultar el scrollbar en Chrome */\n*::-webkit-scrollbar {\n  width: 0 !important;\n}\n\n/* Estilos específicos para el componente app-cards-real-estate */\n:host {\n  display: block !important;\n  width: 100% !important;\n  max-width: 100% !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  box-sizing: border-box !important;\n}\n\n/* Asegurar que todos los contenedores del componente usen todo el ancho */\n:host > * {\n  width: 100% !important;\n  max-width: 100% !important;\n  box-sizing: border-box !important;\n}\n\n/* Contenedor de filtros también debe usar todo el ancho */\n.filter-bar-container-mobile,\n.filter-bar-container-desktop {\n  width: 100% !important;\n  max-width: 100% !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  box-sizing: border-box !important;\n}\n\n/* ======================================\n   FILTER BAR AND CARD CONTAINER FIXES\n   ====================================== */\n\n/* Base filter container styles */\n.filter-bar-container-mobile {\n  width: 100%;\n  position: relative;\n}\n\n.filter-bar-container-desktop {\n  width: 100%;\n  margin-bottom: 0;\n}\n\n/* Improved filter bar mobile */\n.filter-bar-mobile {\n  background: #fff;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  padding: 0.75rem;\n  z-index: 10;\n  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  display: none !important; /* Forzar que esté oculto por defecto */\n  opacity: 0;\n  visibility: hidden;\n}\n\n.filter-bar-mobile.show {\n  display: block !important; /* Forzar que se muestre cuando tenga la clase show */\n  opacity: 1 !important;\n  visibility: visible !important;\n  z-index: 10;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n}\n\n.filter-bar-mobile.hide {\n  transform: translateY(-10%);\n  opacity: 0;\n  visibility: hidden;\n}\n\n/* Filter toggle button */\n.toggle-filter-btn {\n  margin: 0px 10px;\n  background-color: #ff8c00;\n  color: #ffffff;\n  border: 2px solid transparent;\n  border-radius: 8px;\n  padding: 0.5rem;\n  margin-bottom: 1rem;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.3s, transform 0.2s;\n  width: auto;\n  display: flex;\n  align-items: center;\n}\n\n.toggle-filter-btn:hover {\n  background-color: #e57a00;\n  transform: scale(1.02);\n}\n\n/* Barra de filtros */\n.filter-bar-mobile,\n.desktop-filter-bar {\n  margin-bottom: 0.25rem;\n}\n\n/* Filter inputs and controls */\n.filter-bar-mobile input,\n.desktop-filter-bar input,\n.filter-bar-mobile select,\n.desktop-filter-bar select,\n.filter-bar-mobile button,\n.desktop-filter-bar button,\n.filter-bar-mobile .date-picker,\n.desktop-filter-bar .desktop-date-picker {\n  flex: 1 1 auto;       /* Todos ocupan el mismo espacio disponible */\n  min-width: 110px;      /* Puedes ajustar este valor según el espacio que dispongas */\n  padding: 0.5rem;       /* Asegura consistencia en el padding */\n  border: 2px solid #F09502;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  width: 100% !important;\n  height: 2.25rem !important;\n  box-sizing: border-box;\n}\n\n.filter-bar-mobile .filter-btn {\n  flex: 1 1 calc(50% - 10px);\n  text-align: center;\n}\n\n.filter-buttons {\n  display: flex;\n  width: 100%;\n  gap: 6px;\n}\n\n.filter-bar-mobile input[type=\"text\"],\n.desktop-filter-bar input[type=\"text\"],\n.filter-bar-mobile select,\n.desktop-filter-bar select,\n.filter-bar-mobile button,\n.desktop-filter-bar button {\n  flex: 1;\n  padding: 0.5rem;\n  border: 2px solid #F09502;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  height: 2.25rem; \n  padding: 0.25rem 0.5rem;\n}\n\n.filter-bar-mobile select.order-by-dropdown,\n.desktop-filter-bar select.order-by-dropdown {\n  margin-right: 10px;\n}\n\n.filter-bar-mobile button,\n.desktop-filter-bar button {\n  background-color: #FF8C00;\n  color: #FFFFFF;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n}\n\n.filter-bar-mobile button:hover,\n.desktop-filter-bar button:hover {\n  background-color: #E57A00;\n  transform: scale(1.01);\n}\n\n.filter-btn,\n.reset-button {\n  background-color: #ff8c00;\n  color: #ffffff;\n  border: none !important;\n  cursor: pointer;\n  transition: background-color 0.3s, transform 0.2s;\n  width: 100% !important;\n  height: 100% !important;\n}\n\n.filter-btn:hover,\n.reset-button:hover {\n  background-color: #e57a00;\n  transform: scale(1.02);\n}\n\n/* Date picker container */\n.date-picker-container {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  background-color: #fff;\n  gap: 4px;\n  border: 2px solid #F09502;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  height: 2.25rem;\n  padding: 0 8px !important;\n  width: 100% !important;\n  box-sizing: border-box;\n}\n\n.desktop-date-picker,\n.date-picker {\n  position: relative;\n  padding: 0px;\n}\n\n.date-picker-toggle {\n  color: gray;\n}\n\n.desktop-date-picker-input,\n.date-picker {\n  flex: 1;\n}\n\n.desktop-date-picker-input {\n  border: none !important;\n  background: transparent !important;\n  padding: 0 4px !important;\n  height: 90% !important;\n  font-size: 0.9rem !important;\n  width: 40% !important;\n}\n\n/* Cards container */\n.cards-container {\n  width: 100% !important;\n  max-width: 100% !important;\n  overflow-y: auto;\n  box-sizing: border-box;\n  margin: 0 !important;\n  padding: 0 10px !important;\n  position: relative;\n  z-index: 2; /* Asegurar que el contenedor de cards esté por encima del fondo */\n}\n\n.cards-container .row {\n  width: 100% !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  box-sizing: border-box;\n  display: flex !important;\n  flex-wrap: wrap !important;\n}\n\n/* Card styling */\n.cards-container .col-lg-4,\n.cards-container .col-md-6,\n.cards-container .col-12 {\n  padding: 0.5rem !important;\n  transition: transform 0.2s;\n  flex: 0 0 auto !important;\n  width: 100% !important;\n  max-width: 100% !important;\n  box-sizing: border-box !important;\n}\n\n/* Estilos específicos para tarjetas */\napp-card-real-estate {\n  display: block;\n  width: 100%;\n  height: 100%;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  overflow: hidden;\n  position: relative;\n  z-index: 2; /* Asegurar que las cards estén por encima del fondo */\n}\n\n/* Navegación y paginación */\n.navigationCards {\n  width: 100% !important;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  margin-bottom: 100px;\n}\n\n.navigationCards nav {\n  margin-right: 5px;\n}\n\n.page-item a {\n  color: #f09502 !important;\n}\n\n.pagination-controls {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n  margin: 1rem auto;\n  padding: 0.5rem;\n  width: 100%;\n}\n\n.pagination-controls .btn-prev,\n.pagination-controls .btn-next {\n  background-color: #ff8c00;\n  color: #ffffff;\n  border: 2px solid #ffffff;\n  border-radius: 8px;\n  padding: 0.5rem;\n  font-size: 1rem;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background-color 0.3s, transform 0.2s;\n}\n\n.pagination-controls .btn-prev:hover:not([disabled]),\n.pagination-controls .btn-next:hover:not([disabled]) {\n  background-color: #e57a00;\n  transform: scale(1.05);\n}\n\n.pagination-controls .btn-prev[disabled],\n.pagination-controls .btn-next[disabled] {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.btn-page {\n  padding: 8px 14px;\n  border: 1px solid #d48402;\n  background-color: transparent;\n  color: #d48402;\n  border-radius: 20px;\n  cursor: pointer;\n  transition: background-color 0.3s, color 0.3s, border-color 0.3s;\n  font-size: 14px;\n}\n\n.btn-page.active {\n  background-color: #d48402;\n  color: #fff;\n  font-weight: bold;\n  border-color: #d48402;\n}\n\n.btn-page:hover:not(.active) {\n  background-color: rgba(212, 132, 2, 0.2);\n  color: #d48402;\n}\n\n.ellipsis {\n  padding: 8px 12px;\n  color: #999;\n  cursor: default;\n  font-size: 14px;\n}\n\n.btn-prev:hover,\n.btn-next:hover {\n  background-color: rgba(212, 132, 2, 0.2);\n  color: #d48402;\n}\n\n.no-properties-message {\n  text-align: center;\n  color: #fff;\n  font-size: 1.5rem;\n  font-weight: bold;\n  margin: 2rem auto;\n  padding: 1rem;\n  border-radius: 15px;\n  border: 3px solid #f09502;\n}\n\n/* Scrollbar personalizado para contenedores con scroll */\n.scrollable-container::-webkit-scrollbar {\n  width: 12px;\n}\n\n.scrollable-container::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 10px;\n  border: 1px solid #F09502;\n}\n\n.scrollable-container::-webkit-scrollbar-thumb {\n  background: #F09502;\n  border-radius: 10px;\n  border: 1px solid #f1f1f1;\n}\n\n.scrollable-container::-webkit-scrollbar-thumb:hover {\n  background: #d48402;\n}\n\n.scrollable-container::-webkit-scrollbar,\n.scrollable-container::-webkit-scrollbar {\n  width: 12px !important;\n}\n\n/* Angular Material overrides */\n::ng-deep .mat-date-range-input-container.mat-date-range-input-container {\n  align-items: normal;\n}\n\n::ng-deep .mat-date-range-input-start-wrapper {\n  width: 50% !important;\n  max-width: 50% !important;\n}\n\n::ng-deep .mat-date-range-input-end-wrapper {\n  width: 50% !important;\n  max-width: 50% !important;\n}\n\n::ng-deep .mat-date-range-input-separator {\n  margin: 8px 4px !important;\n  color: gray;\n}\n\n/* ======================================\n   RESPONSIVE MEDIA QUERIES\n   ====================================== */\n\n/* Mobile (Small screens) */\n@media (max-width: 576px) {\n  /* Show mobile filters, hide desktop */\n  .filter-bar-container-desktop {\n    display: none !important;\n  }\n  \n  .filter-bar-container-mobile {\n    display: block !important;\n  }\n\n  /* Mobile filter toggle behavior */\n  .filter-bar-mobile {\n    display: none !important;\n    opacity: 0 !important;\n    visibility: hidden !important;\n  }\n  \n  .filter-bar-mobile.show {\n    display: block !important;\n    width: 97vw !important;\n    opacity: 1 !important;\n    visibility: visible !important;\n  }\n  \n  /* Single column layout for filters */\n  .filter-bar-mobile.show .custom-grid {\n    display: flex !important;\n    flex-direction: column !important;\n    gap: 0.75rem !important;\n    width: 100% !important;\n  }\n  \n  /* Single column cards - IMPORTANTE: Asegurar ancho completo */\n  .cards-container {\n    padding: 0 5px !important;\n    height: calc(100vh - 200px) !important; /* ✅ Reducir altura para iPhone SE */\n    width: 100% !important;\n    max-width: 100% !important;\n    margin: 0 !important;\n    position: relative;\n    z-index: 2; /* Asegurar que esté por encima del fondo azul */\n  }\n  \n  .cards-container .row {\n    display: flex !important;\n    flex-direction: column !important;\n    width: 100% !important;\n    padding: 0 !important;\n    margin: 0 !important;\n  }\n  \n  .cards-container .col-lg-4,\n  .cards-container .col-md-6,\n  .cards-container .col-12 {\n    width: 100% !important;\n    max-width: 100% !important;\n    flex: 0 0 100% !important;\n    padding: 0.375rem !important;\n    margin: 0 !important;\n  }\n  \n  /* Asegurar que la navbar-router-container no tenga padding extra */\n  .navbar-router-container {\n    padding: 0 !important;\n    width: 100% !important;\n  }\n  \n  /* Ocultar scrollbar en móvil */\n  .scrollable-container::-webkit-scrollbar {\n    display: none;\n  }\n  \n  .scrollable-container {\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n  }\n  \n  /* Pagination en móvil */\n  .pagination-controls {\n    display: flex;\n    justify-content: center;\n    gap: 1rem;\n    width: 100%;\n  }\n}\n\n/* Tablet (Small to medium screens) */\n@media (min-width: 577px) and (max-width: 767px) {\n  /* Show mobile filters, hide desktop */\n  .filter-bar-container-desktop {\n    display: none !important;\n  }\n  \n  .filter-bar-container-mobile {\n    display: block !important;\n  }\n  \n  /* Mobile filter toggle behavior */\n  .filter-bar-mobile {\n    display: none !important;\n    opacity: 0 !important;\n    visibility: hidden !important;\n  }\n  \n  .filter-bar-mobile.show {\n    display: block !important;\n    width: 94vw !important;\n    opacity: 1 !important;\n    visibility: visible !important;\n  }\n  \n  /* Two column layout for filters */\n  .filter-bar-mobile.show .custom-grid {\n    display: grid !important;\n    grid-template-columns: repeat(2, 1fr) !important;\n    gap: 0.5rem !important;\n    width: 100% !important;\n  }\n  \n  .filter-bar-mobile.show .custom-grid > div:nth-last-child(2),\n  .filter-bar-mobile.show .custom-grid > div:last-child {\n    grid-column: span 2 !important;\n  }\n  \n  /* Two column cards - IMPORTANTE: Asegurar ancho completo */\n  .cards-container {\n    padding: 0 5px !important;\n    height: calc(100vh - 260px) !important;\n    width: 100% !important;\n    max-width: 100% !important;\n    margin: 0 !important;\n    position: relative;\n    z-index: 2; /* Asegurar que esté por encima del fondo azul */\n  }\n  \n  .cards-container .row {\n    display: grid !important;\n    grid-template-columns: repeat(2, 1fr) !important;\n    gap: 0.5rem !important;\n    width: 100% !important;\n    padding: 0.25rem !important;\n    margin: 0 !important;\n  }\n  \n  .cards-container .col-lg-4,\n  .cards-container .col-md-6,\n  .cards-container .col-12 {\n    width: 100% !important;\n    max-width: 100% !important;\n    flex: none !important;\n    padding: 0.25rem !important;\n    margin: 0 !important;\n  }\n  \n  /* Asegurar que la navbar-router-container no tenga padding extra */\n  .navbar-router-container {\n    padding: 0 !important;\n    width: 100% !important;\n  }\n  \n  .custom-grid .custom-col.first-row {\n    flex: 1 1 50%;\n    max-width: 50%;\n  }\n  \n  .custom-grid .custom-col.second-row {\n    flex: 1 1 100%;\n    max-width: 100%;\n  }\n}\n\n/* iPad and larger tablets (768px - 1024px) */\n/* Corrección para iPad y tablets (768px - 1366px) */\n/* Mejorar layout del grid de filtros para iPad y tablets */\n@media (min-width: 768px) and (max-width: 1366px) {\n  /* Estilos generales para el contenedor mobile y sus elementos */\n  .filter-bar-container-mobile {\n    display: block !important;\n    position: relative !important;\n    z-index: 100 !important;\n    width: 100% !important;\n    padding: 0 10px !important;\n    box-sizing: border-box !important;\n  }\n  \n  /* Ocultar barra de filtros desktop */\n  .filter-bar-container-desktop {\n    display: none !important;\n  }\n  \n  /* Botón toggle centrado y con buen tamaño */\n  .toggle-filter-btn {\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    width: 100% !important;\n    margin: 0 0 15px 0 !important;\n    padding: 10px !important;\n    background-color: #ff8c00 !important;\n    color: white !important;\n    border-radius: 8px !important;\n    border: none !important;\n    font-size: 16px !important;\n    cursor: pointer !important;\n  }\n  \n  /* Estilos para la barra de filtros cuando está oculta */\n  .filter-bar-mobile {\n    display: none !important;\n  }\n  \n  /* Estilos para la barra de filtros cuando está visible */\n  .filter-bar-mobile.show {\n    display: block !important;\n    width: 100% !important;\n    background: white !important;\n    border-radius: 8px !important;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1) !important;\n    padding: 15px !important;\n    margin-bottom: 20px !important;\n    box-sizing: border-box !important;\n  }\n  \n  /* Estructura de grid mejorada con más espacio entre elementos */\n  .filter-bar-mobile.show .custom-grid {\n    display: grid !important;\n    grid-template-columns: repeat(2, 1fr) !important;\n    gap: 15px !important;\n    width: 100% !important;\n  }\n\n  /* Dar suficiente altura a cada elemento del grid */\n  .filter-bar-mobile.show .custom-grid > div {\n    min-height: 45px !important;\n  }\n  \n  /* Estilos para los inputs, selects y date pickers */\n  .filter-bar-mobile.show input,\n  .filter-bar-mobile.show select {\n    width: 100% !important;\n    height: 45px !important;\n    padding: 8px 12px !important;\n    border: 2px solid #F09502 !important;\n    border-radius: 8px !important;\n    font-size: 14px !important;\n    background-color: white !important;\n    box-sizing: border-box !important;\n  }\n  \n  /* Mejorar el contenedor del date picker */\n  .filter-bar-mobile.show .date-picker-container {\n    display: flex !important;\n    align-items: center !important;\n    width: 100% !important;\n    height: 45px !important;\n    padding: 0 12px !important;\n    border: 2px solid #F09502 !important;\n    border-radius: 8px !important;\n    background-color: white !important;\n    box-sizing: border-box !important;\n  }\n  \n  /* Mejorar la visibilidad de las fechas */\n  .filter-bar-mobile.show .desktop-date-picker-input {\n    width: 40% !important;\n    height: 35px !important;\n    border: none !important;\n    background: transparent !important;\n    font-size: 14px !important;\n    text-align: center !important;\n    box-sizing: border-box !important;\n  }\n  \n  /* Estilos para el botón de resetear filtros */\n  .filter-bar-mobile.show .filter-buttons {\n    grid-column: span 2 !important;\n    width: 100% !important;\n  }\n  \n  .filter-bar-mobile.show .filter-btn {\n    width: 100% !important;\n    height: 45px !important;\n    padding: 8px 12px !important;\n    background-color: #ff8c00 !important;\n    color: white !important;\n    border: none !important;\n    border-radius: 8px !important;\n    font-size: 16px !important;\n    cursor: pointer !important;\n    box-sizing: border-box !important;\n  }\n\n  /* Asegurar que los elementos ocupen todo el espacio */\n  .filter-bar-mobile.show .col-lg,\n  .filter-bar-mobile.show .col-lg-4,\n  .filter-bar-mobile.show .col-md-6,\n  .filter-bar-mobile.show .col-sm-6,\n  .filter-bar-mobile.show .col-sx-12 {\n    width: 100% !important;\n    padding: 0 !important;\n    margin: 0 !important;\n  }\n  \n  /* Posicionamiento de elementos en grid para mayor claridad */\n  .filter-bar-mobile.show .custom-grid > div:nth-child(1) {\n    grid-column: 1 / 2 !important;\n    grid-row: 1 / 2 !important;\n  }\n  \n  .filter-bar-mobile.show .custom-grid > div:nth-child(2) {\n    grid-column: 2 / 3 !important;\n    grid-row: 1 / 2 !important;\n  }\n  \n  .filter-bar-mobile.show .custom-grid > div:nth-child(3) {\n    grid-column: 1 / 2 !important;\n    grid-row: 2 / 3 !important;\n  }\n  \n  .filter-bar-mobile.show .custom-grid > div:nth-child(4) {\n    grid-column: 2 / 3 !important;\n    grid-row: 2 / 3 !important;\n  }\n  \n  .filter-bar-mobile.show .custom-grid > div:nth-child(5) {\n    grid-column: 1 / 3 !important;\n    grid-row: 3 / 4 !important;\n  }\n}\n\n/* Ajustes para el contenedor de tarjetas */\n/* Corrección específica para el grid de filtros manteniendo el ancho de las cards */\n@media (min-width: 768px) and (max-width: 1366px) {\n  /* Estilos generales para el contenedor mobile y sus elementos */\n  .filter-bar-container-mobile {\n    display: block !important;\n    position: relative !important;\n    z-index: 100 !important;\n    width: 100vw !important; /* Usar viewport width */\n    max-width: 100vw !important;\n    padding: 0 10px !important;\n    box-sizing: border-box !important;\n  }\n  \n  /* Ocultar barra de filtros desktop */\n  .filter-bar-container-desktop {\n    display: none !important;\n  }\n  \n  /* Botón toggle */\n  .toggle-filter-btn {\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    width: calc(100% - 20px) !important;\n    margin: 0 10px 15px 10px !important;\n  }\n  \n  /* Estilos para la barra de filtros cuando está visible */\n  .filter-bar-mobile.show {\n    display: block !important;\n    width: calc(100% - 20px) !important; /* Ancho completo con margen lateral */\n    margin: 0 10px !important;\n    background: white !important;\n    border-radius: 8px !important;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1) !important;\n    padding: 15px !important;\n    box-sizing: border-box !important;\n  }\n  \n  /* Estructura de grid simplificada: 2 columnas, y el botón abajo ocupando todo el ancho */\n  .filter-bar-mobile.show .custom-grid {\n    display: grid !important;\n    grid-template-columns: repeat(2, 1fr) !important;\n    gap: 15px !important;\n    width: 100% !important;\n  }\n  \n  /* El botón de resetear filtros ocupa todo el ancho */\n  .filter-bar-mobile.show .custom-grid > div:last-child {\n    grid-column: 1 / 3 !important; /* Span 2 columnas */\n  }\n  \n  /* Centrar el texto del botón */\n  .filter-bar-mobile.show .filter-btn {\n    display: flex !important;\n    justify-content: center !important;\n    align-items: center !important;\n    width: 100% !important;\n    height: 45px !important;\n    background-color: #ff8c00 !important;\n    color: white !important;\n    font-size: 16px !important;\n    border: none !important;\n    border-radius: 8px !important;\n  }\n  \n  /* Mejorar inputs y selects */\n  .filter-bar-mobile.show input,\n  .filter-bar-mobile.show select,\n  .filter-bar-mobile.show .date-picker-container {\n    width: 100% !important;\n    height: 45px !important;\n    padding: 8px 12px !important;\n    border: 2px solid #F09502 !important;\n    border-radius: 8px !important;\n    box-sizing: border-box !important;\n  }\n}\n\n/* MANTENER LOS ESTILOS DE LAS CARDS QUE YA FUNCIONAN CORRECTAMENTE */\n@media (min-width: 768px) and (max-width: 1366px) {\n  /* No tocar el estilo de las cards */\n  .cards-container {\n    padding: 0 10px !important;\n    width: 100% !important; /* Usar ancho del contenedor padre */\n    max-width: 100% !important;\n    height: calc(100vh - 260px) !important;\n    margin: 0 !important;\n    box-sizing: border-box !important;\n    position: relative;\n    z-index: 2; /* Asegurar que esté por encima del fondo azul */\n  }\n\n  /* Configuración de grid de 2 columnas ocupando todo el ancho */\n  .cards-container .row {\n    display: grid !important;\n    grid-template-columns: repeat(2, 1fr) !important;\n    gap: 1rem !important;\n    width: 100% !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    box-sizing: border-box !important;\n  }\n\n  /* Asegurar que cada celda del grid ocupe su espacio */\n  .cards-container .col-lg-4,\n  .cards-container .col-md-6,\n  .cards-container .col-12 {\n    width: 100% !important;\n    max-width: 100% !important;\n    flex: none !important;\n    padding: 0 !important;\n    margin-bottom: 0.25rem !important;\n    box-sizing: border-box !important;\n  }\n\n  /* Asegurar que la tarjeta ocupe todo el ancho de su contenedor */\n  app-card-real-estate {\n    display: block !important;\n    width: 100% !important;\n    height: 100% !important;\n  }\n\n  .toggle-filter-btn {\n    width: 200px !important; /* Ancho fijo reducido */\n    margin: 0 0 15px 10px !important; /* Alineado a la izquierda con margen izquierdo */\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    height: 45px !important;\n    background-color: #ff8c00 !important;\n    color: white !important;\n    border: none !important;\n    border-radius: 8px !important;\n    font-size: 16px !important;\n    box-sizing: border-box !important;\n  }\n}\n\n\n\n\n\n/* Large tablets and small desktops (1025px - 1366px) */\n@media (min-width: 1024px) and (max-width: 1366px) {\n  /* Hide mobile filters, show desktop */\n  .filter-bar-container-mobile {\n    display: none !important;\n  }\n  \n  .filter-bar-container-desktop {\n    display: block !important;\n  }\n  \n  /* Horizontal flex layout for desktop filters */\n  .desktop-filter-bar .custom-grid {\n    display: flex !important;\n    flex-wrap: nowrap !important;\n    gap: 10px !important;\n    width: 100% !important;\n    align-items: center !important;\n  }\n  \n  /* Equal width columns */\n  .desktop-filter-bar .custom-col {\n    flex: 1 1 0 !important;\n    min-width: 0 !important;\n    max-width: none !important;\n  }\n  \n  /* Three column cards for large tablets/small desktops */\n  .cards-container {\n    height: calc(100vh - 250px) !important;\n    padding: 0 10px !important;\n    width: 100% !important;\n    max-width: 100% !important;\n    position: relative;\n    z-index: 2; /* Asegurar que esté por encima del fondo azul */\n  }\n  \n  .cards-container .row {\n    display: grid !important;\n    grid-template-columns: repeat(3, 1fr) !important;\n    gap: 1rem !important;\n    width: 100% !important;\n    padding: 0.5rem !important;\n  }\n  \n  .cards-container .col-lg-4,\n  .cards-container .col-md-6,\n  .cards-container .col-12 {\n    width: 100% !important;\n    max-width: 100% !important;\n    flex: none !important;\n    padding: 0 !important;\n    margin-bottom: 0.5rem !important;\n  }\n  \n  .custom-grid .custom-col.first-row {\n    flex: 1 1 33.33%;\n    max-width: 33.33%;\n  }\n  \n  .custom-grid .custom-col.second-row {\n    flex: 1 1 50%;\n    max-width: 50%;\n  }\n  \n  /* Date picker container en desktop */\n  .desktop-filter-bar .date-picker-container {\n    flex: 1 1 auto;\n    min-width: 180px;\n    max-width: 200px;\n    padding: 0.5rem;\n  }\n  \n  .desktop-filter-bar .date-picker-container input {\n    font-size: 0.9rem;\n  }\n  \n  /* Resetear la estructura del grid para una fila única */\n  .desktop-filter-bar .row.w-100.g-2.custom-grid {\n    display: flex !important;\n    flex-direction: row !important;\n    flex-wrap: nowrap !important;\n    width: 100% !important;\n    gap: 10px;\n    margin: 0 !important;\n  }\n  \n  /* Dimensiones uniformes para todas las columnas */\n  .desktop-filter-bar .custom-col,\n  .desktop-filter-bar .custom-col.first-row,\n  .desktop-filter-bar .custom-col.second-row,\n  .desktop-filter-bar .custom-col.col-reset {\n    flex: 1 !important;\n    width: auto !important;\n    max-width: none !important;\n    padding: 0 !important;\n    margin: 0 !important;\n  }\n  \n  /* Uniformidad en inputs, selects y date picker */\n  .desktop-filter-bar input[type=\"text\"],\n  .desktop-filter-bar select,\n  .desktop-filter-bar .date-picker-container {\n    width: 100% !important;\n    height: 2.25rem !important;\n    padding: 0 8px !important;\n    min-width: unset !important;\n    max-width: unset !important;\n  }\n}\n\n/* Larger desktops (1367px+) */\n@media (min-width: 1367px) {\n  /* Hide mobile filters, show desktop */\n  .filter-bar-container-mobile {\n    display: none !important;\n  }\n  \n  .filter-bar-container-desktop {\n    display: block !important;\n  }\n  \n  /* Desktop filter layout */\n  .desktop-filter-bar {\n    display: flex !important;\n    flex-direction: row !important;\n    align-items: center;\n    width: 100%;\n    gap: 10px;\n    justify-content: space-between;\n  }\n  \n  .desktop-filter-bar .row.w-100.g-2.custom-grid {\n    display: flex !important;\n    flex-direction: row !important;\n    flex-wrap: nowrap !important;\n    width: 100% !important;\n    gap: 10px;\n    margin: 0 !important;\n  }\n  \n  .desktop-filter-bar .custom-col {\n    flex: 1 !important;\n    width: auto !important;\n    max-width: none !important;\n    padding: 0 !important;\n    margin: 0 !important;\n  }\n  \n  .desktop-filter-bar input[type=\"text\"],\n  .desktop-filter-bar select,\n  .desktop-filter-bar .date-picker-container {\n    width: 100% !important;\n    height: 2.25rem !important;\n    min-width: unset !important;\n    max-width: unset !important;\n  }\n  \n  /* Standard card grid */\n  .cards-container {\n    height: calc(100vh - 170px);\n    padding: 0 10px;\n    width: 100% !important;\n    max-width: 100% !important;\n    position: relative;\n    z-index: 2; /* Asegurar que esté por encima del fondo azul */\n  }\n  \n  /* Ajustar el botón de resetear filtros */\n  .desktop-filter-bar .filter-buttons {\n    width: 100% !important;\n    display: flex;\n    height: 2.25rem !important;\n    flex: 1 !important;\n  }\n  \n  .desktop-filter-bar .filter-buttons .reset-button {\n    width: 100% !important;\n    height: 100% !important;\n    min-width: unset !important;\n    max-width: unset !important;\n    white-space: nowrap;\n  }\n  \n  /* Date picker en desktop grande */\n  .date-picker-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n  }\n  \n  .date-picker-container input.desktop-date-picker-input {\n    font-size: 0.92rem;\n    text-align: center;\n    padding: 0 4px;\n    height: 35px;\n    line-height: 1.2;\n    box-sizing: border-box;\n  }\n  \n  .date-picker-toggle {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 35px;\n  }\n}\n\n/* Ajustes específicos para diferentes rangos de pantalla */\n@media (max-width: 1440px) and (min-width: 1325px) {\n  .cards-container {\n    height: calc(100vh - 250px);\n    position: relative;\n    z-index: 2; /* Asegurar que esté por encima del fondo azul */\n  }\n}\n\n@media (max-width: 1325px) {\n  .cards-container {\n    height: calc(100vh - 310px);\n    position: relative;\n    z-index: 2; /* Asegurar que esté por encima del fondo azul */\n  }\n}\n\n@media (min-width: 992px) {\n  .filter-bar-mobile button,\n  .desktop-filter-bar button {\n    min-width: 80px;\n    width: auto;\n    flex: 0 0 auto;\n  }\n}\n\n/* Solución final para grid desktop - 3 columnas */\n\n/* Solución final para grid desktop - 3 columnas con scrollbar visible */\n\n/* Larger desktops (1367px+) */\n@media (min-width: 1367px) {\n  /* Asegurar que tenemos 3 columnas */\n  .cards-container {\n    display: flex !important;\n    flex-wrap: wrap !important;\n    width: 100% !important;\n    max-width: 100% !important;\n    height: calc(100vh - 170px) !important;\n    padding: 0 10px !important;\n    overflow-y: auto !important;\n    position: relative;\n    z-index: 2; /* Asegurar que esté por encima del fondo azul */\n  }\n\n  /* Ajustar el contenedor de las tarjetas */\n  .cards-container.row {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n    width: 100% !important;\n  }\n\n  /* Cada columna ocupa exactamente 1/3 del espacio */\n  .cards-container .col-lg-4 {\n    flex: 0 0 33.333333% !important;\n    max-width: 33.333333% !important;\n    padding: 0.5rem !important;\n    box-sizing: border-box !important;\n  }\n\n  /* Asegurar que cada tarjeta ocupa todo el ancho de su columna */\n  app-card-real-estate {\n    display: block !important;\n    width: 100% !important;\n    height: 100% !important;\n  }\n  \n  /* Restaurar scrollbar en desktop grande */\n  .scrollable-container::-webkit-scrollbar {\n    display: block !important;\n    width: 12px !important;\n  }\n  \n  .scrollable-container {\n    -ms-overflow-style: auto !important;\n    scrollbar-width: auto !important;\n  }\n  \n  /* Restaurar estilos de scrollbar personalizados */\n  .scrollable-container::-webkit-scrollbar-track {\n    background: #f1f1f1 !important;\n    border-radius: 10px !important;\n    border: 1px solid #F09502 !important;\n  }\n  \n  .scrollable-container::-webkit-scrollbar-thumb {\n    background: #F09502 !important;\n    border-radius: 10px !important;\n    border: 1px solid #f1f1f1 !important;\n  }\n  \n  .scrollable-container::-webkit-scrollbar-thumb:hover {\n    background: #d48402 !important;\n  }\n}\n\n/* Large tablets and small desktops (1025px - 1366px) */\n@media (min-width: 1025px) and (max-width: 1366px) {\n  /* Asegurar que tenemos 3 columnas también aquí */\n  .cards-container {\n    display: flex !important;\n    flex-wrap: wrap !important;\n    width: 100% !important;\n    max-width: 100% !important;\n    height: calc(100vh - 220px) !important;\n    padding: 0 10px !important;\n    overflow-y: auto !important;\n    position: relative;\n    z-index: 2; /* Asegurar que esté por encima del fondo azul */\n  }\n\n  /* Ajustar el contenedor de las tarjetas */\n  .cards-container.row {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n    width: 100% !important;\n  }\n\n  /* Cada columna ocupa exactamente 1/3 del espacio */\n  .cards-container .col-lg-4 {\n    flex: 0 0 33.333333% !important;\n    max-width: 33.333333% !important;\n    padding: 0.5rem !important;\n    box-sizing: border-box !important;\n  }\n\n  /* Asegurar que cada tarjeta ocupa todo el ancho de su columna */\n  app-card-real-estate {\n    display: block !important;\n    width: 100% !important;\n    height: 100% !important;\n  }\n  \n  /* Restaurar scrollbar también para medianos desktop */\n  .scrollable-container::-webkit-scrollbar {\n    display: block !important;\n    width: 12px !important;\n  }\n  \n  .scrollable-container {\n    -ms-overflow-style: auto !important;\n    scrollbar-width: auto !important;\n  }\n  \n  /* Restaurar estilos de scrollbar personalizados */\n  .scrollable-container::-webkit-scrollbar-track {\n    background: #f1f1f1 !important;\n    border-radius: 10px !important;\n    border: 1px solid #F09502 !important;\n  }\n  \n  .scrollable-container::-webkit-scrollbar-thumb {\n    background: #F09502 !important;\n    border-radius: 10px !important;\n    border: 1px solid #f1f1f1 !important;\n  }\n  \n  .scrollable-container::-webkit-scrollbar-thumb:hover {\n    background: #d48402 !important;\n  }\n}\n\n/* Corregir alineación del contenedor de paginación */\n.pagination-controls {\n  flex: 0 0 100% !important;\n  width: 100% !important;\n  justify-content: center !important;\n  margin-top: 1rem !important;\n  padding: 0.5rem !important;\n}\n\n/* Corregir problemas con el ng-container */\n.cards-container > ng-container {\n  display: contents !important;\n}\n\n/* ======================================\n   SPINNER STYLES\n   ====================================== */\n.spinner-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: #181b25;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n  backdrop-filter: blur(2px);\n}\n\n.spinner-container mat-spinner {\n  width: 80px !important;\n  height: 80px !important;\n  margin-bottom: 30px;\n}\n\n.spinner-container .loading-text {\n  color: white;\n  font-size: 20px;\n  font-weight: 500;\n  text-align: center;\n  margin-top: 20px;\n  font-family: \"Montserrat\", sans-serif;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n/* Asegurar que el spinner tenga el color correcto */\n.spinner-container .frontProgress {\n  color: #f09502 !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
